import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SupportModal from './SupportModal';

const Footer = () => {
  const [showSupport, setShowSupport] = useState(false);

  return (
    <footer className="py-12 w-full bg-surface border-t border-line">
      <div className="w-full px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="space-y-4">
            <Link to="/" className="inline-block hover:opacity-80 transition-opacity">
              <img src="/logo.png" alt="BunyadKar" className="h-8 w-auto" />
            </Link>
            <p className="text-sm text-muted">Copyright © 2026 BunyadKar</p>
          </div>
          <div className="space-y-4 md:pl-8">
            <p className="text-sm text-muted">
              Empowering early-stage founders with structured virtual incubation, group mentorship, and the tools to build successful startups.
            </p>
          </div>
          <div className="space-y-4 md:pl-16">
            <div className="flex space-x-2 justify-end">
              {/* LinkedIn */}
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-text/10 hover:bg-chart/20 flex items-center justify-center transition-colors">
                <svg className="w-4 h-4 text-text" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              {/* X / Twitter */}
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-text/10 hover:bg-chart/20 flex items-center justify-center transition-colors">
                <svg className="w-4 h-4 text-text" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              {/* Facebook */}
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-text/10 hover:bg-chart/20 flex items-center justify-center transition-colors">
                <svg className="w-4 h-4 text-text" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
            <div className="text-right space-y-2">
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=ahmedbinaasim@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-text hover:text-muted transition-colors block font-medium"
              >
                Contact Us
              </a>
              <Link to="/register" className="text-sm text-text hover:text-muted transition-colors block font-medium">
                Create an account
              </Link>
              <Link to="/legal/privacy" className="text-sm text-text hover:text-muted transition-colors block">
                Privacy Policy
              </Link>
              <Link to="/legal/terms" className="text-sm text-text hover:text-muted transition-colors block">
                Terms of Service
              </Link>
              <button
                onClick={() => setShowSupport(true)}
                className="text-sm text-text hover:text-muted transition-colors block font-medium text-right w-full"
              >
                Support
              </button>
            </div>
          </div>
        </div>
      </div>
      <SupportModal open={showSupport} onClose={() => setShowSupport(false)} />
    </footer>
  );
};

export default Footer;
